module.exports = __webpack_public_path__ + "static/media/Shuhaliia.28db28d9.jpg";